module.exports = __webpack_public_path__ + "img/L1060767.685fd689.jpg";